export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      title: true,
      name: 'Point Of Sale',
      class: ''
    },
    {
      name: 'Product',
      icon: 'icon-cup',
      children: [
        {
          name: 'Product',
          url: '/pos/product'
        },
        {
          name: 'Category',
          url: '/pos/category'
        }
      ]
    },
    {
      name: 'Transaction',
      icon: 'icon-basket',
      children: [
        {
          name: 'Transaction',
          url: '/pos/transaction'
        },
        {
          name: 'History',
          url: '/pos/history'
        }
      ]
    },
    {
      title: true,
      name: 'External',
      class: ''
    },
    {
      name: 'Product',
      icon: 'icon-cup',
      children: [
        {
          name: 'Product',
          url: '/external/product'
        },
        {
          name: 'Category',
          url: '/external/category'
        }
      ]
    },
    {
      name: 'Outlets 🆕',
      url: '/external/outlet',
      icon: 'fa fa-map-marker'
    },
    {
      name: 'Gallery',
      icon: 'icon-camera',
      children: [
        {
          name: 'Gallery',
          url: '/external/gallery'
        },
        {
          name: 'Category',
          url: '/external/gallery/category'
        }
      ]
    },
    {
      name: 'News',
      url: '/external/news',
      icon: 'fa fa-newspaper-o'
    },
    {
      name: 'Video',
      url: '/external/video',
      icon: 'fa fa-play'
    },
    {
      name: 'Franchise',
      url: '/external/franchise',
      icon: 'fa fa-hand-lizard-o'
    },
    {
      name: 'Transaction',
      icon: 'icon-basket',
      children: [
        {
          name: 'Transaction',
          url: '/external/transaction'
        },
        {
          name: 'History',
          url: '/external/history'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js